import React from "react";
import Icon from "@mdi/react";
import { FiUserCheck } from "react-icons/fi";

interface CardsProps {
  titulosmall: string;
  dados: string;
  icone: string;
  rodape: string;
  cor?: string;
}

export default function Cards({ titulosmall, dados, icone, rodape, cor = '#4361ee' }: CardsProps) {
  return (
    <div className="card h-100" style={{ boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}>
      <div className="card-body" style={{ padding: '12px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
          <div style={{ minWidth: 0 }}>
            <small className="text-muted" style={{ display: 'block', lineHeight: 1.2 }}>{titulosmall}</small>
            <h3 className="mt-2 mb-2" style={{ fontSize: '1.5rem' }}>{dados}</h3>
            <small className="text-muted" style={{ display: 'block', lineHeight: 1.2 }}>{rodape}</small>
          </div>
          <div style={{ 
            backgroundColor: cor,
            padding: '8px',
            borderRadius: '8px',
            opacity: 0.9,
            flexShrink: 0
          }}>
            <Icon path={icone} size={1} color="white" />
          </div>
        </div>
      </div>
    </div>
  );
}
